var chunkMapping = {
	"0": [
		4652
	],
	"3": [
		4055,
		4585
	],
	"78": [
		5086
	],
	"163": [
		5173
	],
	"164": [
		5174
	],
	"167": [
		5177
	],
	"168": [
		5178
	],
	"169": [
		5179
	],
	"170": [
		5180
	],
	"171": [
		5181
	],
	"172": [
		5182
	],
	"173": [
		5183
	],
	"174": [
		5184
	],
	"175": [
		5185
	],
	"176": [
		5186
	],
	"177": [
		5187
	],
	"178": [
		5188
	],
	"179": [
		5189
	],
	"180": [
		5190
	],
	"181": [
		5191
	],
	"182": [
		5192
	],
	"183": [
		5193
	],
	"184": [
		5194
	],
	"185": [
		5195
	],
	"186": [
		5196
	]
};
var idToExternalAndNameMapping = {
	"4055": [
		"default",
		"./nuorder-components",
		3672
	],
	"4585": [
		"default",
		"./helios-components",
		3672
	],
	"4652": [
		"default",
		"./Containers",
		3582
	],
	"5086": [
		"default",
		"./OrderlessInvoices",
		3582
	],
	"5173": [
		"default",
		"./AsyncEventTracker",
		3582
	],
	"5174": [
		"default",
		"./HostWrapper",
		3582
	],
	"5177": [
		"default",
		"./CheckoutV3",
		3582
	],
	"5178": [
		"default",
		"./CheckoutConfirmation",
		3582
	],
	"5179": [
		"default",
		"./ContactCreditCards",
		3582
	],
	"5180": [
		"default",
		"./AuditDialog",
		3582
	],
	"5181": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3582
	],
	"5182": [
		"default",
		"./InvoiceDialog",
		3582
	],
	"5183": [
		"default",
		"./PaymentDueModal",
		3582
	],
	"5184": [
		"default",
		"./PaymentModal",
		3582
	],
	"5185": [
		"default",
		"./PaymentHistory",
		3582
	],
	"5186": [
		"default",
		"./PaymentConfigurations",
		3582
	],
	"5187": [
		"default",
		"./PaymentPreferences",
		3582
	],
	"5188": [
		"default",
		"./ManagePaymentProcessing",
		3582
	],
	"5189": [
		"default",
		"./MobilePaymentsWrapper",
		3582
	],
	"5190": [
		"default",
		"./PayPage",
		3582
	],
	"5191": [
		"default",
		"./Challenge",
		3582
	],
	"5192": [
		"default",
		"./ManagePaymentMethods",
		3582
	],
	"5193": [
		"default",
		"./LightspeedReports",
		3582
	],
	"5194": [
		"default",
		"./ActivateLightspeedPayments",
		3582
	],
	"5195": [
		"default",
		"./MarketingLandingPage",
		3582
	],
	"5196": [
		"default",
		"./ShippingPromotionsListContainer",
		3582
	]
};
var idToRemoteMap = {
	"4055": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4585": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4652": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5086": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5173": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5174": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5195": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5196": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}